exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome-cardsslider-component{border:none}@media (max-width:768px){.welcome-cardsslider-component{padding-left:0!important;padding-right:0!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/welcome/cardsslider.scss
// module id = 1038
// module chunks = 0